import React from "react";

import "./Navbar.css";


const Navbar = ({ search, setSearch }) => {
    const handleChange = (e) => {
        setSearch(e.target.value);
    };

    return (
        <nav className='navbar'>
       
            <div className='navbar_search'>
                <h1>Latest CryptoCurrency Price</h1>
                <input
                    type='text'
                    placeholder='Search...'
                    value={search}
                    onChange={handleChange}
                />
            </div>

        </nav>
    );
};

export default Navbar;
